import Swal, { SweetAlertResult } from 'sweetalert2';

/** Must match backend `DEMO_OUTBOUND_CODE` (company-access.service). */
export const DEMO_OUTBOUND_CODE = 'DEMO_OUTBOUND_BLOCKED';

const DEMO_MESSAGE_HINT = 'demo account';

export function isDemoModeSession(): boolean {
  return localStorage.getItem('demoMode') === 'true';
}

export function setDemoModeSession(demoMode: boolean): void {
  const next = Boolean(demoMode);
  const prev = localStorage.getItem('demoMode') === 'true';
  localStorage.setItem('demoMode', String(next));
  if (prev !== next) {
    window.dispatchEvent(new CustomEvent('demoModeChanged', { detail: next }));
  }
}

export function isDemoOutboundError(errorBody: unknown): boolean {
  if (!errorBody || typeof errorBody !== 'object') {
    return false;
  }
  const body = errorBody as { code?: unknown; message?: unknown };
  if (body.code === DEMO_OUTBOUND_CODE) {
    return true;
  }
  const message =
    typeof body.message === 'string'
      ? body.message
      : typeof (body.message as { message?: unknown })?.message === 'string'
        ? String((body.message as { message: string }).message)
        : '';
  return message.toLowerCase().includes(DEMO_MESSAGE_HINT) && message.toLowerCase().includes('billing');
}

/** Friendly demo → Billing dialog (Mark Nov 2–3). */
export function showDemoOutboundBlockedDialog(): Promise<SweetAlertResult> {
  return Swal.fire({
    title: 'Demo account',
    html:
      'You can create and edit loads on a demo account. Posting to load boards unlocks after billing is set up.<br><br>' +
      'Go to <b>Settings → Billing</b> to choose a plan and complete checkout.',
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: 'Go to Billing',
    cancelButtonText: 'OK',
    confirmButtonColor: '#437eb3',
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.href = '#/app/settings/billing';
    }
    return result;
  });
}

/** @returns true when the caller should abort the outbound action. */
export function blockIfDemoOutbound(): boolean {
  if (!isDemoModeSession()) {
    return false;
  }
  void showDemoOutboundBlockedDialog();
  return true;
}
